(() => {
  'use strict';
  const config = document.currentScript.dataset;
  const root = (config.root || '/').replace(/\/?$/, '/');
  const destinations = { art: 'pages/art-prints', wear: 'collections/all-products', portrait: 'pages/portrait' };
  const storageKey = 'baf-shopping-category-v1';
  const validCategory = value => Object.hasOwn(destinations, value) ? value : '';

  function categoryFromURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin) return '';
      const path = url.pathname.replace(/\/$/, '');
      if (/\/pages\/art-prints$/.test(path) || /\/products\/art-prints-/.test(path) || /\/collections\/art-prints$/.test(path)) return 'art';
      if (/\/pages\/(portrait|make-portrait)$/.test(path) || /\/products\/(framed-canvas-1|canvas-framed|unframed-canvas|canvas-unframed|framed-poster|fine-art-paper-framed|fine-art-paper-unframed)$/.test(path)) return 'portrait';
      if (/\/(collections|products)\/[^/]+(?:\/products\/[^/]+)?$/.test(path)) return 'wear';
    } catch (_) {}
    return '';
  }

  let category = '';
  function rememberCategory() {
    let saved = '';
    try { saved = validCategory(sessionStorage.getItem(storageKey)); } catch (_) {}
    category = validCategory(config.category) || categoryFromURL(location.href) || saved || category || categoryFromURL(document.referrer);
    if (category) {
      try { sessionStorage.setItem(storageKey, category); } catch (_) {}
    }
  }
  rememberCategory();

  class BafContinueShopping extends HTMLElement {
    connectedCallback() {
      this.observer ??= new MutationObserver(() => this.updateLink());
      this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
      this.updateLink();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
    updateLink() {
      const link = this.querySelector('a');
      const href = root + destinations[category || 'wear'];
      if (link && link.getAttribute('href') !== href) link.setAttribute('href', href);
    }
  }
  if (!customElements.get('baf-continue-shopping')) customElements.define('baf-continue-shopping', BafContinueShopping);
  window.addEventListener('pageshow', () => {
    rememberCategory();
    document.querySelectorAll('baf-continue-shopping').forEach(element => element.updateLink());
  });
})();
